export default {
  title: '全部',
  example: {
    label: '例子',
    required: '请输入例子'
  },
  remindRange: {
    label: '数据提醒范围',
    required: '请输入数据提醒范围'
  },
  remindType: {
    label: '提醒类型',
    required: '请选择提醒类型',
    placeholder: '请选择',
    remindSubmit: '表单提交时提醒',
    remindSave: '表单保存时提醒',
    remindChangeCode: '字段数据变更时提醒',
    remindFormCode: '表单字段时间提醒',
    remindAuto: '自动定时提醒',
    remindAppoint: '指定时间提醒',
    remindFormCodePerson: '表单字段时间提醒'
  },
  remindTime: {
    repeatType: {
      label: '重复提醒',
      required: '请选择重复提醒类型',
      placeholder: '请选择',
      oneTime: '仅提醒一次',
      everyDay: '每天提醒',
      everyWeek: '每周提醒',
      everyMonth: '每月提醒',
      everyQuarter: '每季度提醒',
      everyYear: '每年提醒',
      everySomeDay: '每隔指定天数'
    },
    remindDay: {
      required: '请输入天数',
      suffix: '天'
    },
    remindNum: {
      required: '请输入分钟数'
    },
    changeCodeList: {
      label: '变更字段',
      required: '请选择变更字段'
    },
    remindStartDate: {
      label: '提醒开始时间',
      required: '请选择提醒开始时间'
    },
    remindEndDate: {
      label: '提醒结束时间',
      required: '请选择提醒结束时间'
    },
    remindTime: {
      label: '提醒时间',
      required: '请选择提醒时间'
    },
    startDateSet: {
      label: '提醒开始时间',
      placeholder: '请选择',
      required: '请选择提醒开始时间'
    },
    endDateSet: {
      label: '提醒结束时间',
      placeholder: '请选择',
      required: '请选择结束时间'
    },
    personRemind: {
      label: '提醒时间',
      placeholder: '请选择',
      formFieldrequired: '请选择表单字段',
      remindTimeRequired: '请选择提醒时间',
      startDateSet: {
        placeholder: '请选择表单字段'
      }
    },
    remindEndDateType: {
      newerEnd: '永远不结束',
      oneTime: '指定时间'
    },
    remindWhen: {
      today: '当天',
      before: '之前',
      after: '之后'
    },
    timeUnit: {
      min: '分钟',
      day: '天'
    }
  },
  datePlaceholder: '请选择时间',
  remindWay: {
    label: '提醒方式',
    required: '请选择提醒方式',
    emailLabel: '邮件',
    emailTitle: '需先绑定邮箱',
    smsLabel: '短信',
    smsTitle: '需消耗短信数据用量，消息内容最长为140字',
    wechatLabel: '微信',
    wechatTitle: '需关注微信服务号并绑定得帆云账号，消息内容最长200字'
  },
  remindObject: {
    label: '提醒对象',
    required: '请选择提醒对象',

    // remind object list
    designatedPersonLabel: '指定人员',
    createdPersonLabel: '创建人',
    roleLabel: '角色',
    tableListPersonLabel: '表单人员',
    tableListcontactInfoLabel: '表单联系方式',

    // object name
    creatorName: '创建人'
  },
  remindContent: {
    label: '提醒内容',
    required: '请输入提醒内容',
    addFormFieldButton: '添加表单字段'
  }
}
